import { useEffect } from "react";
import {
	isMessageToUXP,
	type MessageToUXPHandlerEntry,
} from "../../../renderer/src/message/types";

export function useListenFromRenderer<
	const T extends readonly MessageToUXPHandlerEntry[],
>(handlers: T) {
	useEffect(() => {
		const messageEventHandler = (e: MessageEvent) => {
			if (!isMessageToUXP(e.data)) return;
			handlers.forEach((h) => {
				if (e.data.key === h.key) {
					h.onMessage(e.data);
				}
			});
		};
		window.addEventListener("message", messageEventHandler);
		return () => window.removeEventListener("message", messageEventHandler);
	}, [handlers]);
}
